

<div class="container mt-2 mb-5">
    
    <div class="row">
        <div class="col-12 shadow-lg rounded p-4 fondoNegro" >
            <mat-icon class="float-right rounded pt-2 pb-2 pl-3 pr-3 botonesCerrar" mat-button mat-dialog-close> cancel_presentation</mat-icon>
            <div class="centrarTexto">
                <h3 class="colorLetras"><strong>Registrate</strong></h3>
                <h5><strong>Compra tus Tickets Premium</strong></h5>
            </div>
            <hr>
            

            <form (ngSubmit)="!todoForm.invalid && saveUsuario()" class="mt-4" #todoForm="ngForm">
                <fieldset class="form-group">
                    
                    <fieldset class="form-group">
                    
                    <input type="text" class= "form-control "name ="nombre" placeholder="Nombre Completo" required="required"  [(ngModel)]="usuario.nombre">
                </fieldset>
                    <select class= "form-control colorGris "name ="tipoDocumento" required="required" placeholder="Tipo de documento" [(ngModel)]="usuario.tipoDocumento">
                        
                        <option value="Cedula" >Cédula</option>
                        <option value="Tarjeta de identidad">Tarjeta de Identidad</option>
                        <option value="Pasaporte">Pasaporte</option>
                        <option value="Cedula de Extranjería ">Cédula de extranjería</option>
                    </select>    
                </fieldset>
                <fieldset class="form-group">
                    
                    <input class= "form-control "name ="id" placeholder="Numero De Documento" required="required"  [(ngModel)]="usuario.numeroDocumento">
                </fieldset>    
                <fieldset class="form-group">
                    
                    <input class= "form-control" id="bloquear2"name ="idconfirmacion" placeholder="Confirmar Numero De Documento" required="required"  [(ngModel)]="confimarcionDocumento">
                    <small *ngIf="this.usuario.numeroDocumento!=confimarcionDocumento" class="colorLetras">Verifica el numero de documento</small>
                </fieldset>   
                <fieldset class="form-group">
                    
                    <input type="email" placeholder="Correo" class= "form-control "name ="correo" required="required"  [(ngModel)]="usuario.correo">
                    <small class="colorLetras">Verifica que hayas escrito bien tu correo, ahí llegaran tus tickets</small>
                </fieldset>
                <fieldset class="form-group">
                    
                    <input type="email" id="bloquear" placeholder="Confirmar Correo" class= "form-control "name ="confirmacorreo" required="required"  [(ngModel)]="confimarcionCorreo">
                    <small *ngIf="this.usuario.correo!=confimarcionCorreo" class="colorLetras">Verifica el correo</small>
                </fieldset>


                <fieldset class="form-group">
                    
                    <input type="password" placeholder="Contraseña" class= "form-control "name ="contrasena" required="required"  [(ngModel)]="usuario.contrasena">
                </fieldset>


                <fieldset class="form-group">
                    
                    <input type="number"  placeholder="Celular" class= "form-control "name ="celular" required="required"  [(ngModel)]="usuario.celular">
                    
                </fieldset>


                <div class="container-fluid">
                    <div class="row">
                        <fieldset class="form-group pl-4 col-12 col-md-4">
                            <input type="checkbox" class="form-check-input" (change) ="publicidad()" id="public" required="required">
                            <small class="form-check-label colorGris"  for="public">Acepto que me envien publicidad</small>
                        </fieldset>
        
                        <fieldset class="form-group pl-4 col-12 col-md-4">
                            <input type="checkbox" class="form-check-input" (change) ="aceptarTerminos()" id="public" required="required">
                            <small class="form-check-label colorGris"  for="public">He leído y acepto <a class="terminos" (click)="terminosYCondiciones()">Términos y Condiciones</a></small>
                        </fieldset>
        
                        <fieldset class="form-group pl-4 col-12 col-md-4">
                            <input type="checkbox" class="form-check-input" (change) ="aceptarTratamiento()" id="public" required="required">
                            <small class="form-check-label colorGris"  for="public" >He leído y acepto <a class="terminos"  (click)="tratamientoDatos()">Tratamiento de datos</a> </small>
                        </fieldset>
        
                    </div>
                </div>

 
 
                
                <div style="text-align: center;">
                    <button class="btn botonLogin mt-2 mb-3"   type="submit">Registrarse</button>
                </div>   
                
            </form>
        </div>    
    </div>
</div>
